import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { IGet, IPut, IPost, IPath, IDelete, httpResponse } from './Fetch.interface';
import { getValidToken } from '../token/token.service';
import { clearTokens } from '../token/token.storage';

const httpService = axios.create({
  baseURL: `${import.meta.env.VITE_BACKEND_URL || ''}/api/v1`,
  headers: {
    'Content-Type': 'Application/json',
    Accept: 'application/json, text/plain, */*',
  },
});

httpService.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = getValidToken();

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpService.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      clearTokens();
    }

    return Promise.reject(error);
  }
);

function get<T>(props: IGet): Promise<httpResponse<T>> {
  return httpService.get<T>(props.url, props.config);
}

function put<T>(props: IPut): Promise<httpResponse<T>> {
  return httpService.put<T>(props.url, props.data, props.config);
}

function post<T>(props: IPost): Promise<httpResponse<T>> {
  return httpService.post<T>(props.url, props.data, props.config);
}

function patch<T>(props: IPath): Promise<httpResponse<T>> {
  return httpService.patch<T>(props.url, props.data, props.config);
}

function deletes<T>(props: IDelete): Promise<httpResponse<T>> {
  return httpService.delete<T>(props.url, props.config);
}

function setDefaultParams(params: object) {
  httpService.defaults.params = params;
}

const httpModule = {
  get,
  put,
  post,
  patch,
  delete: deletes,
  setDefaultParams,
  instance: httpService,
};
export default httpModule;
